import React from 'react';
import { Link } from 'react-router-dom';
export function RegistrationCallout() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-3262">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-3263">
        <div className="flex flex-col items-center justify-center p-8 rounded-xl mb-12 shadow-sm text-center" style={{
        backgroundColor: '#ffffff',
        borderColor: '#c8a84b',
        borderWidth: '2px'
      }} data-id="element-3264">
          <a href="https://www.fentonlakes.com/m7/69--self-defense-class.html" target="_blank" rel="noopener noreferrer" className="text-2xl md:text-3xl font-bold transition-colors hover:opacity-80 mb-4" style={{
          color: '#d32f2f',
          fontFamily: 'Oswald, sans-serif'
        }} data-id="element-3265">
            Register for the next Level 1 Class Here
          </a>
          <p className="text-base text-gray-600" style={{
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-3266">
            Make sure to check our{' '}
            <Link to="/Calendar.html" className="font-semibold text-[#1e3d2f] hover:underline" data-id="element-3267">
              club calendar
            </Link>{' '}
            for upcoming classes.
          </p>
        </div>
      </div>
    </div>;
}